import React from 'react'
import '../assets/css/components/basic-bar.css'

const BasicBar = props =>
  <div className='basic-bar-container'>
    <span className='basic-bar-section'></span>
  </div>

export default BasicBar
